import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//eslint-disable-next-line @typescript-eslint/no-explicit-any
const replaceErrors = (key, value) => {
    if (value instanceof Error) {
        let error = {};
        const { name, message, stack } = value;
        error['name'] = name;
        error['message'] = message;
        if (stack) {
            error['stack'] = stack;
        }
        return error;
    }
    return value;
};
export const logError = (error, descriptor) => {
    const errorString = JSON.stringify(error, replaceErrors, 2);
    if (errorString) {
        // eslint-disable-next-line no-console
        console.error(`${descriptor || ''} ${errorString.replace(/\\n\s{4}/g, '\n\t')}`);
    }
    else {
        // eslint-disable-next-line no-console
        console.error(`${descriptor || ''} Something went wrong...`);
    }
};
export const ErrorDetail = ({ title, subTitle, error }) => {
    if (error) {
        // eslint-disable-next-line no-console
        console.error((title ? title + ':' : '') + error.message);
    }
    return (_jsxs("div", Object.assign({ className: "o-page-align author__summary-error" }, { children: [_jsx("h2", Object.assign({ className: "atc-type-discovery atc-type-insignia--medium" }, { children: title || "Sorry, we've hit a problem" })), subTitle && _jsx("p", Object.assign({ className: "atc-type-picanto" }, { children: subTitle })), !subTitle && (_jsxs("p", Object.assign({ className: "atc-type-picanto" }, { children: ["To tell us about this error, email", ' ', _jsx("a", Object.assign({ href: "mailto:enquiries@autotrader.co.uk" }, { children: "enquiries@autotrader.co.uk" })), "."] })))] })));
};
